@if (config) {
  <div class="highlight">
    <div class="chart" [id]="id"></div>
  </div>
}
